import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    DoughnutController,
    LineController,
    PieController,
    CategoryScale,
    LinearScale,
    Title,
    Tooltip,
    Legend
} from "chart.js";

Chart.register(Tooltip, Legend, CategoryScale, ArcElement, LinearScale, Title, LineElement, LineController, BarController, BarElement, PointElement, DoughnutController, PieController);
Chart.defaults.font.family = "Poppins";

export default function () {
    const dashboardsContainer = document.querySelector('.dashboard-container');

    if (!dashboardsContainer) return;

    const drawStatsChart = function () {
        const dashboardsData = window.dashboardChartsData;

        var ctx = document.getElementById("gsChart");
        var ctx2 = document.getElementById("gsChart2");
        var ctx3 = document.getElementById("gsChart3");
        var ctx4 = document.getElementById("gsChart4");
        var ctx5 = document.getElementById("gsChart5");
        var ctx6 = document.getElementById("gsChart6");

        var options = {
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                }
            },

            legend: {
                display: false,
            },
            tooltips: {
                mode: 'index',
                intersect: true
            },
            scales: {
                x: {
                    display: false,
                },
                y: {
                    type: 'linear',
                    display: true,
                    position: 'left',

                },
                y1: {
                    type: 'linear',
                    display: false,
                }
            }
        }

        new Chart(ctx, {
            type: 'bar',
            options: options,
            data: {
                datasets: [{
                    backgroundColor: chartColors.blue,
                    borderColor: chartColors.blue,
                    label: 'Ilość zamówień / dzień',
                    data: Object.values(dashboardsData.OrderCountByDays)
                }],
                labels: Object.keys(dashboardsData.OrderCountByDays)
            }
        });

        new Chart(ctx2, {
            type: 'line',
            options: options,
            data: {
                datasets: [{
                    backgroundColor: chartColors.blue,
                    borderColor: chartColors.red,
                    pointBorderColor: chartColors.green,
                    pointBackgroundColor: chartColors.green,
                    label: 'Ilość nowych kont / dzień',
                    data: Object.values(dashboardsData.NewAccountByDay)

                }],
                labels: Object.keys(dashboardsData.NewAccountByDay)
            }
        });

        new Chart(ctx3, {
            type: 'bar',
            options: options,
            data: {
                datasets: [{
                    backgroundColor: chartColors.blue,
                    borderColor: chartColors.red,
                    pointBorderColor: chartColors.green,
                    pointBackgroundColor: chartColors.green,
                    label: 'Ilość nowych produktów / dzień',
                    data: Object.values(dashboardsData.NewProductsByDay)

                }],
                labels: Object.keys(dashboardsData.NewProductsByDay)

            }
        });

        new Chart(ctx4, {
            type: 'doughnut',
            options: {
                aspectRatio: 2,
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
            },
            data: {
                datasets: [{
                    label: ' Rozkład zamówień / godziny',
                    data: dashboardsData.OrdersByHours.map(function (item) { return item.Item2; }),
                    backgroundColor: [
                        chartColors.red,
                        chartColors.orange,
                        chartColors.yellow,
                        chartColors.green,
                        chartColors.blue,
                        chartColors.purple,
                        chartColors.grey,
                        chartColors.red,
                        chartColors.orange,
                        chartColors.yellow,
                        chartColors.green,
                        chartColors.blue,
                        chartColors.purple,
                        chartColors.grey,
                        chartColors.red,
                        chartColors.orange,
                        chartColors.yellow,
                        chartColors.green,
                        chartColors.blue,
                        chartColors.purple,
                        chartColors.grey,
                        chartColors.orange,
                        chartColors.orange,
                        chartColors.grey,
                    ]
                }],
                labels: dashboardsData.OrdersByHours.map(function (item) { return item.Item1; })
            }
        });

        new Chart(ctx5, {
            type: 'bar',
            options: options,
            data: {
                datasets: [{
                    backgroundColor: chartColors.blue,
                    borderColor: chartColors.red,
                    pointBorderColor: chartColors.green,
                    pointBackgroundColor: chartColors.green,
                    label: "Kwota zamowień / dzień",
                    data: Object.values(dashboardsData.OrderSumByDay)

                }],
                labels: Object.keys(dashboardsData.OrderSumByDay)
            }
        });

        new Chart(ctx6, {
            type: 'line',
            options: options,
            data: {
                datasets: [{
                    backgroundColor: chartColors.blue,
                    borderColor: chartColors.red,
                    pointBorderColor: chartColors.green,
                    pointBackgroundColor: chartColors.green,
                    label: 'Średnia wartość  zamówienia / dzień',
                    data: Object.values(dashboardsData.AvarageOrderValuePerDay)

                }],
                labels: Object.keys(dashboardsData.AvarageOrderValuePerDay)

            }
        });
    }

    drawStatsChart();
}